export const LOADER = 'LOADER';
export const SERVER_CHECK = 'SERVER_CHECK';
export const AUTH_USER = 'AUTH_USER';
export const TOGGLE_STATUS = 'TOGGLE_STATUS';
export const SHOW_TOAST = 'SHOW_TOAST';
export const ALL_SITES = 'ALL_SITES';
export const ACCEPT_SITE = 'ACCEPT_SITE';
export const REJECT_SITE = 'REJECT_SITE';
export const ALL_SUPPLIERS = 'ALL_SUPPLIERS';
export const SUPPLIER_CREATED = 'SUPPLIER_CREATED';
export const GET_SUPPLIER_USERS = 'GET_SUPPLIER_USERS';
export const SHOW_USER_FORM = 'SHOW_USER_FORM';
export const SHOW_USER_FORM_COMMON = 'SHOW_USER_FORM_COMMON';
export const DASH_USER_CREATED = 'DASH_USER_CREATED';
export const DASH_BUYER_CREATED = 'DASH_BUYER_CREATED';
export const GET_DASH_USERS = 'GET_DASH_USERS';
export const PRIMARY_FILTERS = 'PRIMARY_FILTERS';
export const GET_ALL_DASH_USERS = 'GET_ALL_DASH_USERS';
export const ASSIGN_PRODUCT = 'ASSIGN_PRODUCT';
export const ASSIGN_PRODUCT_DASH = 'ASSIGN_PRODUCT_DASH';
export const GET_ESTIMATES = 'GET_ESTIMATES';
export const GET_VENDOR_USERS = 'GET_VENDOR_USERS';
export const VENDOR_ASSIGN = 'VENDOR_ASSIGN';
export const ASSIGN_FREQUENCY = 'ASSIGN_FREQUENCY';
export const UPDATE_PRIMARY_QUERY = 'UPDATE_PRIMARY_QUERY';
export const UPDATE_SEARCH_QUERY = 'UPDATE_SEARCH_QUERY';
export const GET_FILTERS = 'GET_FILTERS';
export const GET_SITE_REPORTS = 'GET_SITE_REPORTS';
export const UPDATE_SITE_REPORTS = 'UPDATE_SITE_REPORTS';
export const UPDATE_ASSIGN_PRODUCTS = 'UPDATE_ASSIGN_PRODUCTS';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const FILTER_COMPANIES = 'FILTER_COMPANIES';
export const FILTER_CLIENTS = 'FILTER_CLIENTS';
export const FILTER_PRODUCTS = 'FILTER_PRODUCTS';
export const DASHBOARD_DATA = 'DASHBOARD_DATA';
export const REMOVE_ASSIGN_PRODUCT = 'REMOVE_ASSIGN_PRODUCT';
export const REMOVE_ASSIGN_PRODUCT_FROM_COMMON = 'REMOVE_ASSIGN_PRODUCT_FROM_COMMON';
export const UPDATE_DASH_USER = 'UPDATE_DASH_USER';
export const UPDATE_VENDOR_USER = 'UPDATE_VENDOR_USER';
export const UPDATE_PRODUCT_USERS = 'UPDATE_PRODUCT_USERS';
export const GET_DASH_SUPPLIERS = 'GET_DASH_SUPPLIERS';
export const UPDATE_DASH_SUPPLIERS = 'UPDATE_DASH_SUPPLIERS';
export const CREATE_DASH_SUPPLIERS = 'CREATE_DASH_SUPPLIERS';
export const GET_STATES = 'GET_STATES';
export const GET_CITIES = 'GET_CITIES';
export const GET_DASH_BUYERS = 'GET_DASH_BUYERS';
export const UPDATE_DASH_BUYERS = 'UPDATE_DASH_BUYERS';
export const UPDATE_SITE = 'UPDATE_SITE';
export const REMOVE_MAPPING = 'REMOVE_MAPPING';
export const REMOVE_FREQUENCY = 'REMOVE_FREQUENCY';
export const ERROR_DIALOG = 'ERROR_DIALOG';
export const ASSIGN_FLEX_RECEIVE_DATE = 'ASSIGN_FLEX_RECEIVE_DATE';
export const FILTER_SUPPLIERS = 'FILTER_SUPPLIERS';
export const FILTER_RO = 'FILTER_RO';
export const DELETED_SITES = 'DELETED_SITES';
export const UPDATE_ALL_SITE_DATA = 'UPDATE_ALL_SITE_DATA';
export const FILTER_CLIENTS_DASHBOARD = 'FILTER_CLIENTS_DASHBOARD'
export const FILTER_PRODUCTS_CLIENTS_DASHBOARD = 'FILTER_PRODUCTS_CLIENTS_DASHBOARD';
export const FILTER_CAMPAIGNS_CLIENTS_DASHBOARD = 'FILTER_CAMPAIGNS_CLIENTS_DASHBOARD';
export const FILTER_SITES_CLIENTS_DASHBOARD = 'FILTER_SITES_CLIENTS_DASHBOARD';
export const FILTER_CLIENTS_CAMPAIGNS = 'FILTER_CLIENTS_CAMPAIGNS';
export const FILTER_CLIENTS_DASHBOARD_DATA = 'FILTER_CLIENTS_DASHBOARD_DATA';
export const FILTER_ESTIMATES_CLIENTS_DASHBOARD = 'FILTER_ESTIMATES_CLIENTS_DASHBOARD';
export const FILTER_SITES_AUDITOR_DASHBOARD = 'FILTER_SITES_AUDITOR_DASHBOARD';
export const UPDATE_AUDITOR_SITES = 'UPDATE_AUDITOR_SITES';
export const UPDATE_ADMIN_SITE = 'UPDATE_ADMIN_SITE';
